module.exports = __webpack_public_path__ + "img/后台系统.89b0b26e.png";